export default "__VITE_ASSET__dcbeac9d__"